import { useState, useEffect } from "react";
import { BREAKPOINTS_NUM, TBreakPoints } from "@/constants/breakPoints.ts";

const getCurrentBreakpoint = () => {
  const width = window.innerWidth;
  if (width < BREAKPOINTS_NUM.sm) return "xs";
  if (width < BREAKPOINTS_NUM.md) return "sm";
  if (width < BREAKPOINTS_NUM.lg) return "md";
  if (width < BREAKPOINTS_NUM.xl) return "lg";
  if (width < BREAKPOINTS_NUM["2xl"]) return "lg";
  if (width < BREAKPOINTS_NUM["3xl"]) return "2xl";
  return "3xl";
};

function useGetMediaQuery() {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<
    TBreakPoints | "xs"
  >(getCurrentBreakpoint);

  useEffect(() => {
    const handleResize = () => {
      const newSize = getCurrentBreakpoint();
      if (newSize !== currentBreakpoint)
        setCurrentBreakpoint(getCurrentBreakpoint());
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isDown = (breakpoint: TBreakPoints) => {
    return window.innerWidth <= BREAKPOINTS_NUM[breakpoint];
  };

  const isUp = (breakpoint: TBreakPoints) => {
    return window.innerWidth > BREAKPOINTS_NUM[breakpoint];
  };

  return { mediaQuery: currentBreakpoint, isDown, isUp };
}

export default useGetMediaQuery;
